<template>
  <div class="unauthorized-pop-up-container" v-if="isVisible && $route.name !== 'login'">
    <div class="dialog-box" data-aos="fade-up" data-aos-anchor-placement="center-bottom" data-aos-duration="800">

      <div class="dialog-box-content">
        <h4 class="dialog-box-title">{{$t('common.yourSessionHasExpired')}}!</h4>
        <p class="dialog-box-message">
<!--					<span class="span-text">{{$t('common.youWillBeLoggedOutIn')}} <br> {{$t('common.pleaseLoginAgain')}} </span>-->
          <span class="dialog-box-title clock">{{ time }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import {EventUnauthorizedUserPopup} from "@/common/configurations/event-bus.js";
	import {logout} from "@/common/services/login-service";

  export default {
    name: "UnauthorizedUserPopup",
    data() {
      return {
        time: 3,
        isVisible: false,
				index: 1
      }
    },
		mounted() {
      EventUnauthorizedUserPopup.$on("start-unauthorized-user-popup", this.startCounter);
    },
    destroyed() {
      EventUnauthorizedUserPopup.$off("start-unauthorized-user-popup");
    },
    methods: {
      startCounter() {
				if (this.$route.name !== 'login' && localStorage.getItem('jwt')) {
					this.isVisible = true;
					for (this.index; this.index < 4; this.index++) {
						setTimeout(() => {
							this.time--;
							if (this.time === 0) {
								this.isVisible = false;
								this.time = 3;
								this.index = 1;
								logout();
							}
						}, this.index * 1000);
					}
				}
      }
    }
  }
</script>

<style lang="scss" scoped>
@import "@/common/assets/css/_variables.scss";

.unauthorized-pop-up-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
	min-height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;

  .dialog-box {
		background-color: #F2F2F7;
		border: 1px solid #E5E5EA;
    padding: 40px 20px;
    position: relative;
    max-width: 500px;
    width: 90%;

    .dialog-box-content {
      width: 80%;
      margin: auto;
			display: flex;
			flex-direction: column;
			gap: 20px;

      .dialog-box-title {
        text-align: center;
        color: #001f33;
				font-family: Tiempos Text, serif;
				font-weight: 600;
				font-size: 28px;
				line-height: 34px;
				letter-spacing: 0.36px;
				margin: 0;
      }

      .dialog-box-message {
        margin: 0;
				display: flex;
				flex-direction: column;
				gap: 20px;

				.span-text {
					text-align: center;
					color: #636366;
					font-family: Roboto, sans-serif;
					font-weight: 400;
					font-size: 22px;
					line-height: 22px;
					letter-spacing: 0;
				}

        .clock {
          color: #ffb81c;
					font-size: 35px;
					font-family: Roboto, sans-serif;
					font-weight: 600;
        }
      }

    }
  }
}
</style>
